$(document).ready(function () {
  // var listArray = ['Solutions', 'About Us', 'Sustainability'];
  var home_bnr_sldr = new Swiper(".home_bnr_sldr", {
    // Optional parameters
    direction: "horizontal",
    loop: false,
    speed: 1200,
    grabCursor: true,
    mousewheel: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    // If we need pagination
    pagination: {
      el: ".home_bnr_sldr .swiper-pagination",
      clickable: "true",
      // type: 'bullets',
      // renderBullet: function (index, className) {
      //   return (
      //     '<span class="' + className + '">' + '<i></i>' + '<b></b>' + '</span>'
      //   );
      // },
    },
    // Navigation arrows
    navigation: {
      nextEl: ".home_bnr_sldr .swiper-button-next",
      prevEl: ".home_bnr_sldr .swiper-button-prev",
    },
    on: {
      slideChangeTransitionStart: function () {
        // Slide captions
        var swiper = this;
        setTimeout(function () {
          var currentTitle = $(swiper.slides[swiper.activeIndex]).attr(
            "data-title",
          );
          var currentSubtitle = $(swiper.slides[swiper.activeIndex]).attr(
            "data-subtitle",
          );
        });
        gsap.to($(".home_bnr_sldr .current-title"), 0.4, {
          autoAlpha: 0,
          y: -40,
          ease: Power1.easeIn,
        });
        gsap.to($(".home_bnr_sldr .current-subtitle"), 0.4, {
          autoAlpha: 0,
          y: -40,
          delay: 0.05,
          ease: Power1.easeIn,
        });
        gsap.to($(".home_bnr_sldr .commonCTA"), 0.4, {
          autoAlpha: 0,
          y: -40,
          delay: 0.05,
          ease: Power1.easeIn,
        });
      },
      slideChangeTransitionEnd: function () {
        // Slide captions
        var swiper = this;
        var currentTitle = $(swiper.slides[swiper.activeIndex]).attr(
          "data-title",
        );
        var currentSubtitle = $(swiper.slides[swiper.activeIndex]).attr(
          "data-subtitle",
        );
        var currentLink = $(swiper.slides[swiper.activeIndex]).attr(
          "data-link",
        );
        $(".home_bnr_sldr .slide-captions").html(function () {
          return (
            "<h2 class='current-title'>" +
            currentTitle +
            "</h2>" +
            "<p class='current-subtitle'>" +
            currentSubtitle +
            "</p>" +
            "<div class='commonCTA'>" +
            currentLink +
            "</div>"
          );
        });
        gsap.from($(".home_bnr_sldr .current-title"), 0.4, {
          autoAlpha: 0,
          y: 40,
          ease: Power1.easeOut,
        });
        gsap.from($(".home_bnr_sldr .current-subtitle"), 0.4, {
          autoAlpha: 0,
          y: 40,
          delay: 0.15,
          ease: Power1.easeOut,
        });
        gsap.from($(".home_bnr_sldr .commonCTA"), 0.4, {
          autoAlpha: 0,
          y: 40,
          delay: 0.15,
          ease: Power1.easeOut,
        });
      },
    },
  });
  // Slide captions
  var currentTitle = $(home_bnr_sldr.slides[home_bnr_sldr.activeIndex]).attr(
    "data-title",
  );

  var currentSubtitle = $(home_bnr_sldr.slides[home_bnr_sldr.activeIndex]).attr(
    "data-subtitle",
  );

  var currentLink = $(home_bnr_sldr.slides[home_bnr_sldr.activeIndex]).attr(
    "data-link",
  );

  $(".home_bnr_sldr .slide-captions").html(function () {
    return (
      "<h2 class='current-title'>" +
      currentTitle +
      "</h2>" +
      "<p class='current-subtitle'>" +
      currentSubtitle +
      "</p>" +
      "<div class='commonCTA'>" +
      currentLink +
      "</div>"
    );
  });

  gsap.set(
    ".home_bnr_sldr .slide-captions .current-title, .home_bnr_sldr .slide-captions .current-subtitle, .home_bnr_sldr .slide-captions .commonCTA",
    {
      opacity: 0,
      y: 40,
    },
  );
  gsap.to(
    ".home_bnr_sldr .slide-captions .current-title, .home_bnr_sldr .slide-captions .current-subtitle, .home_bnr_sldr .slide-captions .commonCTA",
    {
      opacity: 1,
      y: 0,
      ease: Power1.easeOut,
      duration: 1,
      stagger: {
        each: 0.15,
      },
    },
  );

  var Business_segments_slider = new Swiper(".Business_segments_slider", {
    navigation: {
      nextEl: ".Business_segments_slider-button-next",
      prevEl: ".Business_segments_slider-button-prev",
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2.3,
        spaceBetween: 40,
      },
    },
  });

  $('.latest_news_wrp .ln_cta a').click(function () {
    $('.latest_news_wrp .ln_cta a').removeClass('activelink');
    $(this).addClass('activelink');
    var tagid = $(this).data('tag');
    $('.latest_news_wrp .latest_card').removeClass('active').addClass('hide');
    $('#' + tagid)
      .addClass('active')
      .removeClass('hide');
  });
});


if (window.innerWidth <= 1199) {
} else {
  // Home Overview Animation
  ScrollTrigger.create({
    trigger: ".home_overview",
    start: "top 60%",
    end: "bottom bottom",
    onEnter: () => {
      const hoTl = gsap.timeline();

      // Animate .lineChild2 based on their order
      document
        .querySelectorAll(".home_overview .lines .lineChild2")
        .forEach((element, index) => {
          hoTl.to(
            element,
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "circ.out",
              delay: index * 0.2, // Delay based on position
            },
            0, // Keep them in sequence within the timeline
          );
        });

      // Animate .anims based on their order
      document
        .querySelectorAll(".home_overview .anims")
        .forEach((element, index) => {
          hoTl.to(
            element,
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "circ.out",
              delay: index * 0.1, // Delay based on position
            },
            0, // Keep them in sequence within the timeline
          );
        });
    },
  });

  // Sustainability Animation
  ScrollTrigger.create({
    trigger: ".home_sustainability_wrp",
    start: "top 60%",
    end: "bottom bottom",
    onEnter: () => {
      const hoTl = gsap.timeline();

      hoTl.to(".home_sustainability_wrp .home_sus_pic", {
        width: "100%",
        height: "100%",
      });

      // Animate .lineChild2 based on their order
      document
        .querySelectorAll(".home_sustainability_wrp .lines .lineChild2")
        .forEach((element, index) => {
          hoTl.to(
            element,
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "circ.out",
              delay: index * 0.1, // Delay based on position
            },
            0, // Keep them in sequence within the timeline
          );
        });

      // Animate .anims based on their order
      document.querySelectorAll(".anim").forEach((element, index) => {
        hoTl.to(
          element,
          {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: "circ.out",
            delay: index * 0.1, // Delay based on position
          },
          0, // Keep them in sequence within the timeline
        );
      });
    },
  });

  /* Business_seg */

  ScrollTrigger.create({
    trigger: ".Business_segments",
    start: "top 60%",
    end: "bottom bottom",
    onEnter: () => {
      const hoTl = gsap.timeline();

      // Animate .lineChild2 based on their order
      document
        .querySelectorAll(".Business_segments .lines .lineChild2")
        .forEach((element, index) => {
          hoTl.to(
            element,
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "circ.out",
              delay: index * 0.1, // Delay based on position
            },
            0, // Keep them in sequence within the timeline
          );
        });

      // Animate .anims based on their order
      document
        .querySelectorAll(".Business_segments .anims")
        .forEach((element, index) => {
          hoTl.to(
            element,
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "circ.out",
              delay: index * 0.2, // Delay based on position
            },
            0, // Keep them in sequence within the timeline
          );
        });
    },
  });
  /*  */

  /* Performance : Fact & Figures */

  ScrollTrigger.create({
    trigger: ".Performance_Figures",
    start: "top 60%",
    end: "bottom bottom",
    onEnter: () => {
      const hoTl = gsap.timeline();

      // Animate .lineChild2 based on their order
      document
        .querySelectorAll(".Performance_Figures .lines .lineChild2")
        .forEach((element, index) => {
          hoTl.to(
            element,
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "circ.out",
              delay: index * 0.1, // Delay based on position
            },
            0, // Keep them in sequence within the timeline
          );
        });

      // Animate .anims based on their order
      document
        .querySelectorAll(".Performance_Figures .anims")
        .forEach((element, index) => {
          hoTl.to(
            element,
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "circ.out",
              delay: index * 0.2, // Delay based on position
            },
            0, // Keep them in sequence within the timeline
          );
        });
    },
  });
  /*  */

  ScrollTrigger.create({
    trigger: "#careers",
    start: "top 60%",
    end: "bottom bottom",
    onEnter: () => {
      const hoTl = gsap.timeline();

      // Animate .lineChild2 based on their order
      document
        .querySelectorAll("#careers .lines .lineChild2")
        .forEach((element, index) => {
          hoTl.to(
            element,
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "circ.out",
              delay: index * 0.1, // Delay based on position
            },
            0, // Keep them in sequence within the timeline
          );
        });

      // Animate .anims based on their order
      document.querySelectorAll("#careers .anims").forEach((element, index) => {
        hoTl.to(
          element,
          {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: "circ.out",
            delay: index * 0.2, // Delay based on position
          },
          0, // Keep them in sequence within the timeline
        );
      });
    },
  });
  /*  */
}

// Run GSAP animations when Bootstrap tabs change
document.querySelectorAll('a[data-bs-toggle="tab"]').forEach((tab) => {
  tab.addEventListener("shown.bs.tab", () => {
    initGSAPAnimations(); // Re-initialize GSAP animations
  });
});

// Run GSAP animations when select changes
document.querySelectorAll("select").forEach((select) => {
  select.addEventListener("change", () => {
    initGSAPAnimations(); // Re-initialize GSAP animations
  });
});

// Initialize animations on page load for the first active tab
document.addEventListener("DOMContentLoaded", () => {
  initGSAPAnimations();
});

initGSAPAnimations();
